export const CREATE_PAYMENT_ERROR =
  'Payment create failed, please refresh the page and retry'
export const UPDATE_PAYMENT_ERROR =
  'Payment amount update failed, please refresh the page and retry'
export const PAYMENT_SUCCEED = 'Payment successfully processed'
export const PAYMENT_PROCESSING_ERROR =
  'Payment processing was either canceled or failed'
export const PAYMENT_SUCCEED_TS_IN_PROGRESS =
  'Payment successful! Transaction update in progress'
export const PAYMENT_TRANSACTION_ERROR =
  'Payment transaction failed, please refresh the page and retry'
export const NO_BILLING_COUNTRY_ERROR = 'Billing Country not set!'
